import * as React from "react";
import { AddToCart } from "@grandvisionhq/carts-v2";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useSolutionsEcommContext } from "../../../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
import { SolutionsCTACaption } from "../../../../../components/modules/EcommContent/SolutionsEcommContent/components/SolutionsCTA/components/SolutionsCTACaption.js";
import { mapSolutionToDraftLineItem } from "./map-solution-to-draft-line-item.js";
import { useGetPriceSegment } from "../../../../../../../../hooks/modules/EcommContent/hooks/use-get-price-segment.js";
import { FindAStoreCTA } from "../../../../../../../../components/CTAs/FindAStoreCTA/modules/EcommContent/components/CTAs/FindAStoreCTA/FindAStoreCTA.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { getProductTealiumDescription } from "../../../../../../../../../../utils/utils/get-product-tealium-description.js";
const SolutionsCTA = () => {
  const { getLabel } = useIntl();
  const { routes, activeVariant, product, selectedPurchaseType } = useProductData();
  const { priceSegment } = useGetPriceSegment();
  const { state, actions, selectors } = useSolutionsEcommContext();
  const isConfiguratorValid = selectors.isConfiguratorValid(state);
  const lineItemDraft = mapSolutionToDraftLineItem({
    sku: activeVariant.sku,
    state,
    purchaseType: selectedPurchaseType,
    priceSegment
  });
  if (activeVariant.channelAvailability !== "ONLINE") {
    return /* @__PURE__ */ React.createElement(FindAStoreCTA, { href: routes.stores });
  }
  if (!isConfiguratorValid || !lineItemDraft) {
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: getLabel("products.solutions.addToBasket"),
        onClick: actions.triggerValidationErrors
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      caption: /* @__PURE__ */ React.createElement(SolutionsCTACaption, null),
      lineItemDrafts: [lineItemDraft],
      "data-element-id": "Prod_AddCart",
      "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
    }
  );
};
export {
  SolutionsCTA
};
//# sourceMappingURL=SolutionsCTA.js.map
